@if (loaded) {
  <p-select
    [filter]="true"
    [options]="companyList"
    [disabled]="disabled()"
    [ngModel]="company"
    (ngModelChange)="company = $event; onCompanyChange($event)"
    placeholder="All companies"
    appendTo="body"
    dataKey="id"
    [showClear]="true"
  >
  </p-select>
}
